import { defineMessages } from 'react-intl';

export default defineMessages({
  AcknowledgmentRequiredMessage: {
    id: 'EEOSection.Acknowledgment.RequiredMessage',
    defaultMessage: 'Please complete this required field',
  },
});
